<template>
  <div>
    <div class="cardContainer evaluationHeader" style="padding: 30px">
      <h5 class="mediumTitle">
        {{ $t("label_evaluation_summary_title") }}
      </h5>
      <b-form-group label-class="text-sm-left">
        <template slot="label">
          <!--title-->
          {{ $t("label_evaluation_summary_description") }}
        </template>
        <b-form-textarea
          id="label_evaluation_summary_description"
          v-model="summary"
          type="text"
          required
        />
      </b-form-group>
      <div style="text-align:center;">
        <b-button variant="primary" @click="saveSummary()">
          {{ $t("label_evaluation_requirementEvaluation_post_button") }}
        </b-button>
      </div>
    </div>
    <b-modal
      id="modalInfo"
      v-model="showModalSummary"
      modal-class="modalInfo"
      :title="$t('label_evaluation_summary_modal_title')"
    >
      <div style="padding: 20px">
        {{ $t("label_evaluation_summary_modal_confirmation") }}
      </div>
      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-btn variant="primary" @click="showModalSummary = false">
          {{ $t("Close") }}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "EvaluationSummaryTab",
  computed: { ...mapGetters(["getSelectedEvaluation"]) },
  watch: {
    getSelectedEvaluation: function () {
      this.summary = this.getSelectedEvaluation.evaluation.summary;
    },
  },
  data() {
    return {
      showModalSummary: false,
      summary: null,
    };
  },
  methods: {
    saveSummary() {
      let valuesToUpdate = { summary: this.summary };

      this.$store.dispatch("updateEvaluation", { valuesToUpdate });

      this.showModalSummary = true;
    },
  },
};
</script>
